<div class="pagination-footer" role="status">
  <p class="pagination-footer-text">
    @if (retrievedAt) {
      <span class="pagination-footer-retrieved">
        Retrieved: {{ retrievedAt | crowdctrlFormatDate }} &middot; {{ liveUpdatesStatusText }}
      </span>
      <br />
    }
    @if (totalCount && totalCount > 0) {
      Showing {{ currentCount }} of {{ totalCount }} {{ itemType }} &middot; Page size:
      {{ pageSize }}
    } @else {
      Showing {{ currentCount }} {{ itemType }} &middot; Page size: {{ pageSize }}
    }
  </p>
</div>
